import { ExActionTree } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";
import * as api from "@/api";
import { ApiRequest } from "@/api/types";
import { NotificationFilterCategory } from "@/api/types";

const actions: ExActionTree<State, Actions, Getters, Mutations> = {
  async getNewArrivalNotifications(ctx) {
    try {
      const params: ApiRequest.GetNotifications = {
        category: NotificationFilterCategory.ALL,
        limit: 3,
        offset: 0
      };
      const response = await api.getNotifications(params);
      ctx.commit("getNewArrivalNotificationsSuccess", {
        // NOTE: 新着通知用のテスト
        // newArrivalNotifications: [
        //   {
        //     ...response.data[0],
        //     id: Math.floor(Math.random() * 11)
        //   },
        //   response.data[1],
        //   response.data[2]
        // ]
        newArrivalNotifications: response.data
      });
    } catch (error) {
      throw error;
    }
  },
  async getNotifications(ctx, params) {
    try {
      const response = await api.getNotifications(params);
      ctx.commit("getNotificationsSuccess", {
        notifications: response.data
      });
    } catch (error) {
      throw error;
    }
  },
  async readNotification(ctx, params) {
    const preReadAt = [
      ...ctx.state.notifications,
      ...ctx.state.newArrivalNotifications
    ].find(notification => notification.id === params.notificationId)!.read_at;

    try {
      ctx.commit("readNotificationSuccess", params);
      await api.readNotification(params);
    } catch (error) {
      ctx.commit("readNotificationFailed", { ...params, preReadAt });
      throw error;
    }
  },
  resetHeaderNotificationBadge(ctx) {
    const preNewArrivalNotificationSnapshotForHeaderBadge =
      ctx.state.newArrivalNotificationSnapshotForHeaderBadge;

    if (!ctx.state.newArrivalNotifications.length) return;

    try {
      ctx.commit("setNewArrivalNotificationSnapshotForHeaderBadge");

      const latestNotification = ctx.state.newArrivalNotifications[0];
      if (!latestNotification) return;
      localStorage.setItem(
        "newArrivalNotificationSnapshotForHeaderBadgeKey",
        JSON.stringify(latestNotification)
      );

      // TODO: APIが用意されたらこちらを使用
      // const response = await api.resetHeaderNotificationBadge(params);
    } catch (error) {
      ctx.commit(
        "setNewArrivalNotificationSnapshotForHeaderBadge",
        preNewArrivalNotificationSnapshotForHeaderBadge
      );
      throw error;
    }
  },
  initializeNewArrivalNotificationSnapshotForHeaderBadge(ctx) {
    const newArrivalNotificationSnapshotForHeaderBadge = localStorage.getItem(
      "newArrivalNotificationSnapshotForHeaderBadgeKey"
    );

    if (
      newArrivalNotificationSnapshotForHeaderBadge &&
      newArrivalNotificationSnapshotForHeaderBadge !== "undefined"
    ) {
      ctx.commit(
        "setNewArrivalNotificationSnapshotForHeaderBadge",
        JSON.parse(newArrivalNotificationSnapshotForHeaderBadge)
      );
    }
  }
};

export default actions;
